export interface ScenarioItemFilters {
  teamIds?: number[];
  noTeamSet?: boolean;
  estimationIds?: number[];
  itemTypeIds?: number[];
  itemStatusIds?: number[];
  needsTeamOrEstimate?: boolean;
  isMLImputed?: boolean;
  unparented?: boolean;
  searchText?: string;
}

export const buildScenarioItemFiltersQueryString = (filters?: ScenarioItemFilters): string => {
  if (!filters) return '';

  const params = new URLSearchParams();

  if (filters.teamIds?.length) params.set('teamIds', filters.teamIds.join(','));
  if (filters.noTeamSet) params.set('noTeamSet', 'true');
  if (filters.estimationIds?.length) params.set('estimationIds', filters.estimationIds.join(','));
  if (filters.itemTypeIds?.length) params.set('itemTypeIds', filters.itemTypeIds.join(','));
  if (filters.itemStatusIds?.length) params.set('itemStatusIds', filters.itemStatusIds.join(','));
  if (filters.needsTeamOrEstimate) params.set('needsTeamOrEstimate', 'true');
  if (filters.isMLImputed) params.set('isMLImputed', 'true');
  if (filters.unparented) params.set('unparented', 'true');
  if (filters.searchText?.trim()) params.set('searchText', filters.searchText.trim());

  const queryString = params.toString();
  return queryString ? `?${queryString}` : '';
};
